document.addEventListener('DOMContentLoaded', function() {
  // Group counters by section
  var sections = document.querySelectorAll('.multicolumn[data-section-id]');
  
  sections.forEach(function(section) {
    var counters = section.querySelectorAll('.multicolumn-card__counter-value[data-counter-end]');
    if (counters.length === 0) return;
    
    // Get section-level settings
    var duration = parseInt(section.getAttribute('data-counter-speed')) || 1000;
    var animateOnView = section.getAttribute('data-counter-animate-on-view') === 'true';
    var infinite = section.getAttribute('data-counter-infinite') === 'true';
    var delay = parseInt(section.getAttribute('data-counter-delay')) || 2000;
    
    var isAnimating = false;
    var hasStarted = false;
    
    // Prepare all counters
    var counterConfigs = [];
    counters.forEach(function(counter) {
      var start = parseFloat(counter.getAttribute('data-counter-start'));
      var end = parseFloat(counter.getAttribute('data-counter-end'));
      var increment = parseFloat(counter.getAttribute('data-counter-increment'));
      
      if (isNaN(start) || isNaN(end)) return;
      if (isNaN(increment) || increment === 0) increment = 1;
      
      counterConfigs.push({
        element: counter,
        start: start,
        end: end,
        increment: Math.abs(increment),
        range: Math.abs(end - start)
      });
    });
    
    // Animate all counters in sync
    var animateAllCounters = function() {
      if (isAnimating) return;
      isAnimating = true;
      
      var startTime = Date.now();
      
      var updateAllCounters = function() {
        var elapsed = Date.now() - startTime;
        var progress = Math.min(elapsed / duration, 1);
        
        counterConfigs.forEach(function(config) {
          var currentValue;
          if (config.start < config.end) {
            // Counting up
            currentValue = config.start + (config.range * progress);
          } else {
            // Counting down
            currentValue = config.start - (config.range * progress);
          }
          
          // Round to nearest increment
          var steps = Math.round(currentValue / config.increment) * config.increment;
          config.element.textContent = Math.round(currentValue);
        });
        
        if (progress < 1) {
          requestAnimationFrame(updateAllCounters);
        } else {
          // Ensure all end at exact values
          counterConfigs.forEach(function(config) {
            config.element.textContent = Math.round(config.end);
          });
          
          isAnimating = false;
          if (infinite) {
            setTimeout(animateAllCounters, delay);
          }
        }
      };
      
      requestAnimationFrame(updateAllCounters);
    };
    
    if (animateOnView) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && !hasStarted) {
            hasStarted = true;
            animateAllCounters();
            if (!infinite) {
              observer.disconnect();
            }
          }
        });
      }, { threshold: 0.3 });
      
      observer.observe(section);
    } else {
      animateAllCounters();
    }
  });
});
